import CancelIcon from '@material-ui/icons/Cancel';

import styled from '@emotion/styled';
import theme from '../../themes/default';

const size = {
  default: '6px 16px',
  xs: '2px 8px',
  withCancel: '6px 6px 6px 16px',
};

const getStyles = (
  { isSelected, disabled, hasError, hasWarning },
  isHover = false
) => {
  let background = isHover ? theme.color.grey15 : '';
  let border = theme.color.grey4;
  let color = theme.color.black;

  if (isSelected) {
    background = theme.color.purple2;
    border = theme.color.purple3;
    color = theme.color.purple3;
  }

  if (hasWarning) {
    background = theme.color.designSystem.background.light.warning;
    border = theme.color.yellowDark;
    if (isHover) {
      background = theme.color.yellow1;
      border = theme.color.yellow2;
    }
  }

  if (hasError) {
    border = theme.color.redLight;
  }
  if (disabled) {
    background = '';
    border = theme.color.grey4;
    color = theme.color.grey4;
  }
  return `
    background: ${background};
    border: 1px solid ${border};
    color: ${color};
  `;
};

const getSize = (deleteAction) =>
  deleteAction ? size.withCancel : size.default;

const ChipWrapper = styled('span')`
  ${(props) => getStyles(props)}
  align-items: center;
  border-radius: 18px;
  box-sizing: border-box;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  display: inline-flex;
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
  padding: ${(props) =>
    props.size === 'xs' ? size.xs : getSize(props.deleteAction)};
  :hover {
    ${(props) => getStyles(props, true)}
  }
  :focus {
    ${(props) => !props.isSelected && `background: ${theme.color.grey14};`}
    border: 1px solid ${(props) =>
      props.hasError ? theme.color.redLight : theme.color.grey13};
    color: ${theme.color.grey13};
    outline: none;
  }
`;

const TextWrapper = styled('span')`
  margin: 0 5.67px;
`;

const CancelIconWrapper = styled(CancelIcon)`
  font-size: 20px;
  color: ${theme.color.grey6};
  :hover {
    color: ${theme.color.grey7};
  }
`;

const Status = styled('span')`
  height: 8px;
  width: 8px;
  vertical-align: middle;
  margin-left: ${theme.spacing.xSmall};
  border-radius: ${theme.borderRadius.large};
  background-color: ${theme.color.error};
`;

export { ChipWrapper, TextWrapper, CancelIconWrapper, Status };
